import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormBuilder from 'components/form/builder/FormBuilder';
import get from 'lodash/get';
import FormContext from 'components/form/builder/FormBuilderContext';
import { schemaGenerator } from './schema';

function NewCustomerDataForm({ configuration, handleSubmit }) {
  const parameters = get(configuration, 'parameters.Parameters.value') || {};

  const schema = useMemo(
    () => schemaGenerator(parameters),
    [parameters],
  );

  return (
    <FormContext.Provider value={parameters}>
      <FormBuilder
        schema={schema}
        onSubmit={handleSubmit}
      />
    </FormContext.Provider>
  );
}

NewCustomerDataForm.propTypes = {
  configuration: PropTypes.shape({
    versionToken: PropTypes.string.isRequired,
  }),
  handleSubmit: PropTypes.func.isRequired,
};

export default NewCustomerDataForm;
